import mixpanel from '@webtrader/core/mix-panel';

import { EMixpanelProperties } from '../constants';
import { eventNameHelper, userHelper } from '../helpers';
import { IMixpanelSignalInterestProps } from './type';

class SignalAnalysisService {
  public signalInterest = ({ action, symbol }: IMixpanelSignalInterestProps) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    const eventName = eventNameHelper.mapSignalInterestEventName(action);
    mixpanel.track(eventName, {
      [EMixpanelProperties.SYMBOL]: symbol ?? '-',
      ...userAccountProperties
    });
  };
}

const signalAnalysisService = new SignalAnalysisService();
export default signalAnalysisService;
